import { Store } from '../codegen/graphql';

export const isPnlStore = (store: Store): boolean => {
    const result = store.storeNo?.startsWith('P') ?? false;
    return result;
};

export const isPnlStoreTradingAsCashbuild = (store: Store): boolean => {
    const isPnl = isPnlStore(store);
    const isTradingAsCashbuild = store.isTradingAsCashbuild ?? false;
    const result = isPnl && isTradingAsCashbuild;

    return result;
};

export const shouldEnablePnlPriceInput = (store: Store): boolean => {
    return isPnlStore(store) && !isPnlStoreTradingAsCashbuild(store);
};

export const shouldShowPnlPriceInput = (stores: Store[]): boolean => {
    const result = stores.some(
        store => isPnlStore(store) && !isPnlStoreTradingAsCashbuild(store),
    );
    return result;
};

export const shouldDisablePnlPriceInput = (stores: Store[]): boolean => {
    const pnlStores = stores.filter(isPnlStore);
    if (pnlStores.length === 0) {
        return true;
    }

    const allTradingAsCashbuild = pnlStores.every(isPnlStoreTradingAsCashbuild);
    return allTradingAsCashbuild;
};

export const getPnlStoresTradingAsCashbuild = (stores: Store[]): string[] => {
    return stores
        .filter(isPnlStoreTradingAsCashbuild)
        .map(store => store.name || store.storeNo || 'Unknown Store');
};

export const shouldDisableCashbuildPriceInput = (request: any): boolean => {
    if (
        request?.store?.storeNo?.startsWith('P') &&
        !request?.store?.isTradingAsCashbuild
    ) {
        return true;
    }
    return false;
};

export const shouldShowPnlPriceInputForSingleStore = (
    request: any,
): boolean => {
    return (
        (request?.store?.storeNo?.startsWith('P') ?? false) &&
        !request?.store?.isTradingAsCashbuild
    );
};

export const shouldShowCashbuildPriceInput = (stores: Store[]): boolean => {
    const result = stores.some(
        store => !store.storeNo?.startsWith('P') || store.isTradingAsCashbuild,
    );
    return result;
};

export function determineRequiredPriceTypes(stores: Store[]) {
    return {
        needsCashbuildPrice: shouldShowCashbuildPriceInput(stores),
        needsPnlPrice: shouldShowPnlPriceInput(stores),
    };
}
